import { Component } from '@angular/core';

import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'shared-ui-notification-feature-common-notification',
  standalone: true,
  imports: [
    ToastModule
],
  templateUrl: './common-notification.component.html',
  styleUrl: './common-notification.component.scss',
})
export class CommonNotificationComponent {
  navigateToLink(link: string | undefined) {
    if(link){
        const baseUrl = window.location.origin;
        window.open(`${baseUrl}/${link}`, '_blank');
    }
  }
}

